import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { NotificationsService } from "src/app/Services/notifications.service";

import { TranslateService } from "@ngx-translate/core";

import { EmbryoService } from "../../Services/Embryo.service";
import { MetaService } from "src/app/Services/meta-data.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import { LoginUsersService } from "src/app/Services/login-users.service";

@Component({
    selector: "app-notifications",
    templateUrl: "./notifications.component.html",
    styleUrls: ["./notifications.component.scss"],
})
export class NotificationsComponent implements OnInit {
    currentPage = 1;
    totalPage: number = 0;
    lang: string = "";
    notifications: any = [];
    toggleLoading: boolean = false;
    environmentVariables: any;
    user: any;
    constructor(
        private notificationsServices: NotificationsService,
        private translate: TranslateService,
        public embryoService: EmbryoService,
        private router: Router,
        private metaService: MetaService,
        private confgServ: StaticPagesService,
        private auth: LoginUsersService
    ) {
        this.auth.userEmit.subscribe((data) => {
            this.user = data;
        });
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
            if (this.lang == "en")
                this.metaService.setTitle(
                    `Notifications - ${this.environmentVariables?.APP_NAME}`
                );
            else
                this.metaService.setTitle(
                    `الاشعارات - ${this.environmentVariables?.APP_NAME_AR}`
                );
        });
    }

    ngOnInit() {
        this.lang = localStorage.getItem("lang") || "en";
        this.translate.setDefaultLang(this.lang);

        this.getNotifications();
        this.markAsRead();
    }

    openLink(index: number, type: number) {
      console.log('notifcation');
      
        const { item_id, title, item_link } = this.notifications[index];
        const queryParams: any = {};
        var link = false;
        switch (type) {
            case null:
                return;
            case 1:
                break;
            case 2:
                // window.open(item_link, "_self");
                this.router.navigate(["/" + this.lang + "/" + this.notifications[index].slug])
                break;
            case 3:
                queryParams.brand_id = item_id;
                link = true;
                break;
            case 4:
               this.router.navigate([this.lang + '/product/' + 
                         this.notifications[index].item_slug ]);
                // queryParams.category_id = item_id;
                // link = true;
                break;
            case 5:
                this.router.navigate([
                    "/" +
                        this.lang +
                        (!this.user || this.user?.is_guest
                            ? `/orders/order-history/${item_id}`
                            : `/account/order-history/${item_id}`),
                ]);
                break;
            case 6:
                // queryParams.sub_category_id = item_id;
                // link = true;
                  this.router.navigate([this.lang + '/product/' + 
                        this.notifications[index].category_slug +'/' + this.notifications[index].group_slug + '/' + this.notifications[index].item_slug]);
                break;
            case 7:
                queryParams.list_ids = item_id;
                link = true;
                break;
            case 14:
                   this.environmentVariables?.ENABLE_CATEGORY_VIEW ? 
                       this.router.navigate([this.lang + "/category/" + this.notifications[index].category_slug +'/' + this.notifications[index].item_slug]) : 
                        this.router.navigate([this.lang + '/product/' + this.notifications[index].category_slug +'/' + this.notifications[index].item_slug]);
         
                break;
        }
        link
            ? this.router.navigate(["/" + this.lang + "/products"], {
                  queryParams: queryParams,
              })
            : null;
    }
    getNotifications(page: number = this.currentPage) {
        this.toggleLoading = true;
        this.notificationsServices.getNotifications(page).subscribe(
            (res: any) => {
                if (res.code === 200) {
                    this.notifications = res.data.items;
                    this.totalPage = res.data.total;
                }
                this.toggleLoading = false;
            },
            () => (this.toggleLoading = false)
        );
    }

    markAsRead() {
        this.notificationsServices.markAsRead().subscribe();
    }
    onPageChanged(pageNumber: number) {
        this.currentPage = pageNumber;
        this.getNotifications(this.currentPage);
    }
}
